// Helper functions for CV score styling and labels

export const getScoreStyle = (score) => {
  if (score >= 1 && score <= 3) {
    return { backgroundColor: '#ef4444', color: 'white' };
  } else if (score >= 4 && score <= 5) {
    return { backgroundColor: '#f97316', color: 'white' };
  } else if (score >= 6 && score <= 7) {
    return { backgroundColor: '#84cc16', color: 'white' };
  } else if (score >= 8 && score <= 10) {
    return { backgroundColor: '#22c55e', color: 'white' };
  }
  return { backgroundColor: '#6b7280', color: 'white' };
};

export const getScoreLabel = (score) => {
  if (score >= 1 && score <= 3) return "Needs Major Improvement";
  if (score >= 4 && score <= 5) return "Needs Improvement";
  if (score >= 6 && score <= 7) return "Good Progress";
  if (score >= 8 && score <= 10) return "Ready to Submit!";
  return "Needs Review";
};
